import React from 'react';
export function Problem() {
  return <section className="py-20 bg-white" data-id="element-126">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-127">
        <div className="text-center mb-12" data-id="element-128">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-129">
            The Frustrating Reality
          </h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto" data-id="element-130"></div>
        </div>

        <div className="prose prose-lg prose-stone mx-auto text-stone-700" data-id="element-131">
          <p className="text-xl font-semibold text-stone-900 mb-6" data-id="element-132">
            Do you feel betrayed by your own body?
          </p>

          <p className="mb-6" data-id="element-133">
            You wake up feeling light, but by 4:00 PM, your jeans feel two sizes
            too small. You’re eating salads, walking 10k steps, and cutting out
            sugar… yet the "menopause belly" won't budge.
          </p>

          <p className="mb-8" data-id="element-134">
            You look in the mirror and notice your skin is losing its "snap."
            You feel tired, puffy, and—honestly—frustrated because the advice
            that worked in your 20s is now making things{' '}
            <strong className="text-red-700" data-id="element-135">worse.</strong>
          </p>

          <div className="bg-stone-50 border-l-4 border-amber-500 p-8 rounded-r-lg my-10" data-id="element-136">
            <h3 className="text-2xl font-bold text-stone-900 mb-4 mt-0" data-id="element-137">
              Here is the secret the fitness industry won’t tell you:
            </h3>
            <p className="mb-0" data-id="element-138">
              After 45, your Cortisol (stress hormone) is "hijacking" your
              metabolism. When you stress your body with intense exercise or low
              calories, it goes into "Survival Mode"—locking fat directly in
              your abdomen to protect your organs.
            </p>
          </div>
        </div>
      </div>
    </section>;
}